import { render, staticRenderFns } from "./kanonkop-paul-sauer.vue?vue&type=template&id=58d98edb&scoped=true"
import script from "./kanonkop-paul-sauer.vue?vue&type=script&lang=js"
export * from "./kanonkop-paul-sauer.vue?vue&type=script&lang=js"
import style0 from "./kanonkop-paul-sauer.vue?vue&type=style&index=0&id=58d98edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d98edb",
  null
  
)

export default component.exports